import { types } from 'mobx-state-tree';

import { Address, Employment as BaseEmployment } from '../definitions/Common';

import { EmploymentTypeEnum } from '../definitions/EmploymentType';
import { IncomeTypeEnum } from '../definitions/IncomeType';
import { SectorTypeEnum } from '../definitions/SectorType';
import OptionalIdentifier from '../types/OptionalIdentifier';


const MortgageEmployment = types.model('MortgageEmployment', {
    id: OptionalIdentifier,
    address: Address,
    employmentType: types.maybe(EmploymentTypeEnum),
    incomeType: types.maybe(IncomeTypeEnum),
    sectorType: types.maybe(SectorTypeEnum),
});

const Employment = types.compose('Employment', BaseEmployment, MortgageEmployment);

export default Employment;
